import type { CreateVoucherRequest } from '../types';

export const SHIP_TO_TEMPLATE_ROWS = [
  'sap_no_shipto',
  '10604684',
  '11261284',
  '12500999',
] as const;

export const SHIP_TO_TEMPLATE_FILENAME = 'template_ship_to.csv';

export const TARGET_TAB_TO_API_TYPE = {
  general: 'GENERAL',
  'ship-to': 'SHIP_TO',
} as const;

export const DEFAULT_TARGET_CONFIGURATION: CreateVoucherRequest['target_configuration'] =
  {
    target_type: 'GENERAL',
    business_segmentations: [],
    distribution_channels: [],
    business_categories: [],
    shipto_csv_url: null,
    quota: 0,
    max_use_per_user: null,
  };

export const DEFAULT_ACQUISITION_CONFIGURATION: CreateVoucherRequest['acquisition_configuration'] =
  {
    acquisition_type: 'REGULAR',
    valid_day_since_account_signup: null,
  };

export const ACQUISITION_TYPE_SELECT_OPTIONS = [
  { value: 'REGULAR', label: 'Reguler' },
  { value: 'ACCOUNT_ACTIVATION', label: 'Aktivasi akun' },
] as const;

export const ACCOUNT_AGE_SELECT_OPTIONS = [
  { value: 7, label: '7 hari' },
  { value: 14, label: '14 hari' },
  { value: 30, label: '30 hari' },
  { value: 60, label: '60 hari' },
] as const;
